<script module lang="ts">
  import type { Snippet } from "svelte";
  import type { SystemStyleObject } from "@agapi/ui/panda/types";

  export interface LanguagePickerContentProps {
    onclick: () => void;
    flag?: string;
    selected?: boolean;
    css?: SystemStyleObject;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { icon } from "@agapi/ui/panda/patterns";
  import { Button } from "@agapi/ui/button";
  import { languagePickerStyles } from "./language-picker.styles";

  const getFlagUrl = (flag?: string) => {
    switch(flag) {
      case 'GB': return '/flags/gb.svg';
      case 'EU': return '/flags/eu.svg';
      case 'SE': return '/flags/se.svg';
      case 'FI': return '/flags/fi.svg';
      case 'DK': return '/flags/dk.svg';
      case 'NO': return '/flags/no.svg';
      case 'ES': return '/flags/es.svg';
      case 'DE': return '/flags/de.svg';
      case 'en': return '/flags/gb.svg';
      case 'sv': return '/flags/se.svg';
      case 'fi': return '/flags/fi.svg';
      case 'da': return '/flags/dk.svg';
      case 'nb': return '/flags/no.svg';
      case 'es': return '/flags/es.svg';
      case 'de': return '/flags/de.svg';
      default: return '/flags/se.svg';
    }
  }

  const classes = languagePickerStyles.raw()

  const { children, onclick, flag, css: cssProp }: LanguagePickerContentProps = $props();
</script>

<Button
  onclick={onclick}
  size="xs"
  css={{ ...classes.button, ...cssProp }}
  variant="secondary"
>
  <span class={icon({ size: "md", height: "auto", mr: 2 })}>
    <img src={getFlagUrl(flag)} alt={flag} />
  </span>

  {@render children?.()}
</Button>
